module.exports = __webpack_public_path__ + "static/media/thumb-1920-600255.c2077b60.jpg";